<template>
  <v-container>
    <v-row>
      <v-col>
        <coaching-assessment :userId="userId" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CoachingAssessment from "./assessment/CoachingAssessment";

export default {
  name: "ClientCommunication",
  components: {
    CoachingAssessment,
  },
  props: ["userId"],
  data() {
    return {
      tab: "self",
    };
  },
};
</script>

<style scoped></style>
